export enum AdmissionVisitType {
    Admission = 1,
    PatientVisit = 2,
}
